import { useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_PART_ORDERS } from "../../graphql/queries/parts/partOrders.queries";
import { UPDATE_PART_ORDER } from "../../graphql/mutations/parts/partOrder.part.mutation";

const useOpenParts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [metaData, setMetaData] = useState({});
  const [openParts, setOpenParts] = useState([]);
  const [updatePartOrderMutation] = useMutation(UPDATE_PART_ORDER);
  const [getPartOrders] = useLazyQuery(GET_PART_ORDERS, {
    fetchPolicy: "network-only",
  });

  const fetchOpenParts = async ({ query = {}, partOrder = {} }) => {
    setIsLoading(true);
    const { data, error } = await getPartOrders({
      variables: {
        query: query || {},
        partOrder: partOrder || {},
      },
    });
    if (error) {
      console.error(error);
    }
    if (data?.partOrders?.partOrders) {
      setOpenParts(data.partOrders.partOrders);
    }
    if (data?.partOrders?.metaData) {
      setMetaData(data.partOrders.metaData);
    }
    setIsLoading(false);
  };

  const updateOpenPart = async (partOrder) => {
    try {
      // Remove __typename from partOrder object and customer object
      // Copy partOrder
      partOrder = Object.entries(partOrder).reduce((acc, [key, value]) => {
        if (key === "customer") {
          const customer = Object.entries(value).reduce((acc, [key, value]) => {
            if (key !== "__typename") return { ...acc, [key]: value };
            return acc;
          }, {});
          return { ...acc, customer };
        }
        if (key !== "__typename") return { ...acc, [key]: value };
        return acc;
      }, {});
      const { data, error } = await updatePartOrderMutation({
        variables: {
          partOrder: partOrder,
        },
      });
      if (error) {
        console.error(error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    openParts,
    fetchOpenParts,
    isLoading,
    metaData,
    updateOpenPart,
  };
};

export default useOpenParts;
